import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { settings } from '../../app.settings';

const API_PATH = settings.api.url + '/universes';

@Injectable()
export class UniverseService {

  constructor(
    private http: HttpClient
  ) { }

  fetch() {
    return this.http.get(API_PATH);
  }

  flatten(array, level = -1) {
    level++;

    return array.reduce((accumulator, item) => {
      accumulator = accumulator.concat(item);
      item.level = level;

      if (item.children) {
        accumulator = accumulator.concat(this.flatten(item.children, level));
      }

      return accumulator;
    }, []);
  }
}
